// src/components/ErrorBoundary.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('Error caught by boundary:', error, errorInfo);
        if (error.message.includes('401') || error.message.includes('unauthorized')) {
            this.props.navigate('/sign-in');
        }
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="p-4 bg-red-50 text-red-700 rounded-lg">
                    <h2>Something went wrong</h2>
                    <p>{this.state.error.message}</p>
                </div>
            );
        }

        return this.props.children;
    }
}

export const ErrorBoundaryWithNavigation = ({ children }) => {
    const navigate = useNavigate();
    return <ErrorBoundary navigate={navigate}>{children}</ErrorBoundary>;
};